import { Task } from '@/types/tasks';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FilingsContext, Source } from './filings-context';

export const FilingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [filteredFilings, setFilteredFilings] = useState<Task[]>([]);
  const [currentFilingId, setCurrentFilingId] = useState<string | null>(null);
  const [source, setSource] = useState<Source>(null);

  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const onTaskManagementPage = pathname.startsWith('/kintsugi-filings');
    const onFilingsListPage = pathname.startsWith('/filings/list');
    const onFilingDetails = /^\/filings\/[^/]+\/[^/]+$/.test(pathname);
    const onRegistrationPage = pathname.startsWith('/registrations');

    if (!onTaskManagementPage && !onFilingDetails && !onFilingsListPage && !onRegistrationPage) {
      if (source) {
        setSource(null);
      }
      if (filteredFilings.length > 0) {
        setFilteredFilings([]);
      }
      if (currentFilingId) {
        setCurrentFilingId(null);
      }
    }
  }, [location.pathname, source, filteredFilings, currentFilingId]);

  const getNextFiling = (currentId: string): Task | null => {
    if (filteredFilings.length === 0) return null;

    const current = filteredFilings.find(t => t.filing?.id === currentId);
    if (!current) return null;

    let pool: Task[] = filteredFilings;
    if (source === 'task') {
      pool = filteredFilings.filter(t => t.status === current.status);
    }

    if (pool.length < 2) return null;

    const idx = pool.findIndex(t => t.filing?.id === currentId);
    if (idx === -1) return null;

    const nextIdx = (idx + 1) % pool.length;
    return pool[nextIdx];
  };

  return (
    <FilingsContext.Provider
      value={{
        filteredFilings,
        currentFilingId,
        setFilteredFilings,
        setCurrentFilingId,
        getNextFiling,
        source,
        setSource,
      }}
    >
      {children}
    </FilingsContext.Provider>
  );
};
